import { Link } from 'react-router-dom';
import { useHandbookUrl } from '../../../handbookRoute';
import { SearchResultField } from 'framework/ui/field';
import { ListItem, SearchResultsLayoutProps, useListContext } from 'framework/list';
import { Box, Typography } from '@mui/material';

interface HandbookSearchResultItemProps extends SearchResultsLayoutProps {
  row: ListItem;
  index: number;
}

const HandbookSearchResultItem = ({
  row,
  index,
  onKeyUp,
  searchResultsRefs,
  focusedResultIndex,
  setFocusToResults,
}: HandbookSearchResultItemProps) => {
  const { searchBy = () => {} } = useListContext();
  const { getSingleEntityUrl } = useHandbookUrl();
  const path = row.pagePathname.startsWith('/') ? row.pagePathname.slice(1) : row.pagePathname;
  const numberOfAdditionalResults =
    (row.searchResults?.numberOfMatches || 0) - (row.searchResults?.firstResult?.numberOfMatches || 0);

  const clearSearch = () => {
    searchBy('');
  };

  const focused = focusedResultIndex === index;

  return (
    <Box
      component={Link}
      key={row.pagePathname}
      to={getSingleEntityUrl(path)}
      sx={{
        color: 'inherit',
        display: 'block',
        padding: '15px 16px',
        marginBottom: '12px',
        ...(focused && { backgroundColor: 'common.menuItemActive' }),
        '&:hover, &:focus': {
          backgroundColor: 'common.menuItemActive',
          color: 'inherit',
          outline: 'none',
          textDecoration: 'none',
        },
        '& p': {
          margin: 0,
          padding: 0,
        },
        '& > p': {
          display: 'inline',
        },
      }}
      onKeyUp={event => {
        onKeyUp(event, index);
        clearSearch();
      }}
      onClick={clearSearch}
      onFocus={setFocusToResults}
      ref={(link: HTMLAnchorElement | null) => {
        if (link) {
          // eslint-disable-next-line no-param-reassign
          searchResultsRefs[index] = link;
        }
      }}
    >
      <Typography variant="h2" color="primary">
        <SearchResultField source="pageTitle" />
      </Typography>
      {row.searchResults?.firstResult?.data && (
        <>
          <SearchResultField strict source="searchResults" value={row.searchResults?.firstResult?.data} />
          {numberOfAdditionalResults ? (
            <Typography component="i" variant="caption" color="text.secondary" fontStyle="normal" whiteSpace="nowrap">
              {` (+ ${numberOfAdditionalResults} match${numberOfAdditionalResults > 1 ? 'es' : ''})`}
            </Typography>
          ) : null}
        </>
      )}
    </Box>
  );
};

export default HandbookSearchResultItem;
